import React from 'react';
import FooterLinks from './FooterLinks';
import ContactForm from './ContactForm';

const FooterContent = () => {
  return (
    <div className="bg-gray-100 w-full">
      <div className="max-w-[1753px] mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start">
          <FooterLinks />
          <div className="lg:col-span-1">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterContent;